<header class="main-content admin-header">

  <div class="header-left">
    <h5>{{nomeFantasia}}</h5>
    <span>Gestão completa dos módulos e permissões do sistema</span>
  </div>

  <!--Busca-->
  <div class="header-center">
    <div class="search-box">
      <i-lucide class="header-search-icon" name="search" size="15"></i-lucide>

      <input
        type="text"
        placeholder="Buscar em todo o sistema..."
        title="Buscar em todo o sistema"
        [(ngModel)]="termoBusca"
        [matAutocomplete]="auto"
        (input)="filtrar()"
        (keydown.enter)="buscarTudo()" />

      <button
        type="button"
        class="header-search-limpar"
        title="Limpar busca"
        aria-label="Limpar busca"
        *ngIf="termoBusca"
        (click)="limpar()">
        <i-lucide name="x" size="14"></i-lucide>
      </button>

      <mat-autocomplete
        #auto="matAutocomplete"
        class="busca-global-panel"
        [hideSingleSelectionIndicator]="true"
        [displayWith]="exibirTermo"
        (optionSelected)="selecionar($event.option.value)">

        <mat-option class="busca-global-aviso" *ngIf="exibirCarregando" [disabled]="true">
          Buscando resultados...
        </mat-option>

        <mat-option class="busca-global-aviso" *ngIf="exibirVazio" [disabled]="true">
          Nenhum resultado encontrado para “{{ termoAtual }}”.
        </mat-option>

        <ng-container *ngIf="exibirResultados">
          <mat-optgroup *ngFor="let grupo of gruposSugestoes" [label]="grupo.tipo">
            <mat-option
              *ngFor="let item of grupo.itens; trackBy: trackByResultado"
              [value]="item"
              [title]="item.descricao">
              <span class="busca-global-item">
                <span class="busca-global-item-icone">
                  <i-lucide [name]="item.icone" size="16"></i-lucide>
                </span>

                <span class="busca-global-item-texto">
                  <span class="busca-global-item-titulo">{{ item.titulo }}</span>
                  <span class="busca-global-item-modulo">{{ item.modulo }}</span>
                </span>
              </span>
            </mat-option>
          </mat-optgroup>

          <mat-option
            class="busca-global-todos"
            [value]="verTodos"
            title="Ver todos os resultados da busca">
            <span class="busca-global-todos-conteudo">
              <span>Ver todos os resultados ({{ totalSugestoes }})</span>
              <i-lucide name="arrow-right" size="16"></i-lucide>
            </span>
          </mat-option>
        </ng-container>

      </mat-autocomplete>

    </div>
  </div>

  <div class="header-right">
    <button class="btn header-theme-button" title="Personalizar aparência" (click)="abrirPainelTema()">
      <i-lucide name="palette" size="20"></i-lucide>
    </button>

    <app-notificacoes></app-notificacoes>

    <!-- PERFIL -->
    <div class="dropdown-wrapper">
      <div class="user-info" (click)="toggleProfile()">
        <div class="avatar">
          <img *ngIf="previewImage; else avatarInitials" [src]="previewImage" alt="Avatar do usuário" />
          <ng-template #avatarInitials>
            {{ getInitials(nomeSocial || nome) }}
          </ng-template>
        </div>
        <div class="user-text">
          <strong>{{nomeSocial || nome}}</strong>
          <span class="nivel-perfil">{{perfil}}</span>
        </div>
        <span><i-lucide class="header-chevron" name="chevron-down" size="15"></i-lucide></span>
      </div>

      <div class="dropdown profile" *ngIf="showProfile">
        <div class="profile-header">
          <div class="avatar details">
            <img *ngIf="previewImage; else avatarInitialsDetalhe" [src]="previewImage" alt="Avatar do usuário" />
            <ng-template #avatarInitialsDetalhe>{{getInitials(nomeSocial || nome)}}</ng-template>
          </div>
          <div class="drop-details">
            <strong class="name-profile">{{nomeSocial || nome}}</strong>
            <small class="email">{{email}}</small>
            <span class="role">{{perfil}}</span>
          </div>
        </div>

        <a class="dropdown-item" (click)="meuPerfil()"><i-lucide name="user" size="16" color="#717182"></i-lucide> Meu
          Perfil</a>
        <a class="dropdown-item" (click)="configuracao()"><i-lucide name="settings" size="16"
            color="#717182"></i-lucide> Configurações</a>
        <a class="dropdown-item" (click)="trocarCliente()"><i-lucide name="arrow-right-left" size="16"
            color="#717182"></i-lucide> Trocar de Cliente </a>
        <a class="dropdown-item danger" (click)="logout()"><i-lucide name="log-out" size="16"
            color="#717182"></i-lucide> Sair</a>
      </div>
    </div>

  </div>
</header>
